/*eslint complexity: off*/
import React, { useEffect, useState } from 'react';
import JSONView from 'react-json-view';
import { Route, Switch } from 'react-router-dom';

import Request from '~/providers/Request';
import { showLog } from '../../config/routes';
import { LogsProvider } from './context';

function ShowLog({ history }) {
  const { id } = history.location.route.getParams();
  const [log, setLog] = useState();
  useEffect(() => {
    Request.get(`/admin/report/logs/${id}`, null, { normalizeJSON: false }).then((response) => {
      setLog(response);
    })    
    .catch((e) => {
      console.error(e);
    });

  }, [id]);

  return (
    <LogsProvider>
  <Switch><Route
    exact
    path={showLog.spec}
    render={(props) => (<JSONView src={log} name='log' displayObjectSize={false} displayDataTypes={false} />)}
  />
    </Switch>
    </LogsProvider>
  );
}
export default ShowLog;
